var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M639,221.4c-24.8-16.2-42.7-42.1-48.3-72.2c-1.2-6.5-1.9-13.2-1.9-20.1h-79.2l-0.1,317.4     c-1.3,35.5-30.6,64.1-66.5,64.1c-11.1,0-21.6-2.8-30.9-7.7c-21.2-11.2-35.7-33.4-35.7-58.9c0-36.7,29.9-66.6,66.6-66.6     c6.9,0,13.4,1.1,19.6,3.1v-62.1v-18.8c-6.4-0.9-13-1.4-19.6-1.4c-80.4,0-145.8,65.4-145.8,145.8c0,49.3,24.6,93,62.2,119.4     c23.7,16.6,52.5,26.4,83.5,26.4c80.4,0,145.8-65.4,145.8-145.8V283c31.1,22.3,69.1,35.4,110.2,35.4v-61.6v-17.6     C676.9,239.2,656.3,232.7,639,221.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.3,679.2h127.6l-11.7,36.5l-33.1,0v135h-41.3v-135l-41.5,0.1L127.3,679.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.9,679.2h130.6l-11.7,36.5l-36,0v135h-41.3v-135l-41.5,0.1L463.9,679.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "262.7,733.7 303.6,733.7 303.5,850.6 262.9,850.6   "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.8,678.7h40.9v79.9l40.5-39.7l48.8,0l-51.2,49.7l57.4,82.1h-45l-38.3-57l-12.1,11.8v45.2h-40.9V678.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M735.4,678.7h40.9v79.9l40.5-39.7l48.8,0l-51.2,49.7l57.4,82.1h-45l-38.3-57l-12.1,11.8v45.2h-40.9V678.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.1,
    cy: 699.7,
    r: 20.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.8,710.6c-38.7,0-70,31.3-70,70c0,38.7,31.3,70,70,70c38.7,0,70-31.3,70-70    C718.8,742,687.4,710.6,648.8,710.6z M648.8,814.7c-18.8,0-34-15.2-34-34c0-18.8,15.2-34,34-34s34,15.2,34,34    C682.8,799.4,667.6,814.7,648.8,814.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e23c1903349ed85c979ff7a0f2d6b9cd.svg";
export { ForwardRef as ReactComponent };